<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_Quots' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item txQuots">
      <div class="bg-white fh" id='txQuots-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'quotCode'">
                  <a class="link-type" @click.stop="openDrawer(scope.row,'txQuots')">{{ scope.row.quotCode }}</a>
                </span>
              <span v-else-if="item.key==='finishDate'">
                {{ scope.row[item.key] }}
              </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txQuots-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmTypenew"
                     createdFormId="txQuots-dialog"
                     :visible.sync="dialogEditVisible"
                     :otherSubmitModel="otherSubmitModel"
                     :errDetailGuidArray="errDetailGuidArray"
                     :initData="temp" :soltNameArray="soltNameArray">
        <template slot="venGuid">
          <el-input :value="temp.venName" readonly>
            <!--                切换的那个按钮-->
            <el-button slot="append" icon="el-icon-search" @click="()=>{dialogAccessVisible=true}"></el-button>
          </el-input>
        </template>
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>

      <el-dialog class="dialog-mini" top="15vh" v-el-drag-dialog :title="'选择供应商'"
                 :visible.sync="dialogAccessVisible" width="80%">
        <SelectSupplyInfo ref="SelectSupplyInfo" v-if="dialogAccessVisible" :accGuid="accGuid"
                          :venGuid="temp.venGuid" :venName="temp.venName"
                          @close="dialogAccessVisible=false" @closeMoule="closeMoule"/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as txQuots from '@/api/tx_quots';
import * as txQuotsnews from '@/api/tx_quotsnews';
import mytable from '@/utils/crmtableFlowV2';
import SelectSupplyInfo from '@/components/SelectSupplyInfo';
import * as txCompareForms from '@/api/tx_compareforms';

export default {
  name: 'txQuots',
  components: { SelectSupplyInfo },
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_Quot',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {},
      dialogAccessVisible: false,
      dialogEditTime: false,
      accGuid: '',
      soltNameArray: ['venGuid'],
      soltEditTime: false,
      crmTypenew: 'Tx_Quot',
      otherSubmitModel: {},
      errDetailGuidArray: []
    };
  },
  created() {
    const _this = this;
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
    this.otherSubmitModel = {
      othersub() {
        return _this.othersub();
      }
    };
  },
  methods: {

    getApi() {
      if (!this.soltEditTime) {
        return txQuots;
      } else {
        return txQuotsnews;
      }
    },
    beforUpdate() {
      if (this.temp.errDetailGuid) {
        this.errDetailGuidArray = this.temp.errDetailGuid.split('、');
      }
    },
    othersub() {
      return new Promise((resolve, reject) => {
        const temp = this.$refs[this.dataForm].$refs[this.frmData].GetModelData();
        const now = new Date();
        const time = new Date(temp.finishDate).getTime() - now.getTime();
        if (time < 0) {
          this.$message.error('已超过开标时间，请修改开标时间后重试');
          reject(new Error());
        } else if (new Date(temp.finishDate).toDateString() === now.toDateString()) {
          this.$confirm('距离开标时间不足一天, 是否继续保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (temp.directionalInq === '是' && !temp.directionalInstructions) {
              this.$message.error('请填写定向说明');
              reject(new Error());
            } else {
              return resolve(true);
            }
          }).catch(() => {
            reject(new Error());
          });
        } else {
          return resolve(true);
        }
      });
    },
    closeMoule(e) {
      this.$refs.editForm.$refs.frmEditData.AssignmentModel('venGuid', e.map(u => u.id).join(','));
      this.$refs.editForm.$refs.frmEditData.AssignmentModel('venName', e.map(u => u.venName).join(','));
      this.temp.venName = e.map(u => u.venName).join(',');
      this.temp.venGuid = e.map(u => u.id).join(',');
      this.dialogAccessVisible = false;
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnCompareFormFalse':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          }
          this.$prompt('请输入强制开标说明', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(({ value }) => {
            const paramStr = JSON.stringify({
              keyValue: this.multipleSelection[0].id,
              BidOpenInfo: value
            });
            this.listLoading = true;
            txCompareForms.AsyncCompareFormFalse(paramStr).then(res => {
              this.$message({
                message: '强制更新状态成功',
                type: 'success'
              });
              this.listLoading = false;
              this.getList();
            });
          }).catch(() => {
          });

          break;
        case 'btnPublish':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请最少发布一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Publish();
          }
          break;
        case 'btncancel':
          if (this.multipleSelection.length === 0) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.cancel();
          }
          break;
        case 'btnEditTime':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.EditTime();
          }
          break;
        case 'btnDels':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条数据',
              type: 'error'
            });
            return;
          } else {
            this.Dels();
          }
          break;
      }
    },
    Dels() {
      this.$confirm('是否要删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const paramStr = {
          keyValue: this.multipleSelection.map(item => item.id).join(',')
        };
        txQuots.dels(paramStr).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList();
        }).catch((_) => {
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    EditTime() {
      this.soltEditTime = true;
      this.crmTypenew = 'Tx_Quot_FinishDate';
      this.temp = {
        quotId: this.multipleSelection[0].id,
        quotCode: this.multipleSelection[0].quotCode,
        finishDate: this.multipleSelection[0].finishDate,
        remarks: ''
      };
      this.dialogStatus = 'update';
      this.dialogEditVisible = true;
    },
    cancel() {
      const conforms = this.multipleSelection.filter(u => u.state === '询价中' || u.state === '待撤回');
      const paramStr = JSON.stringify({
        // 先找到被选择的数据
        // 找到被选择数据的id,转成字符串格式
        keyValue: conforms.map(u => u.id).join(',')
      });
      this.listLoading = true;
      if (conforms && conforms.length > 0) {
        txQuots.Back(paramStr).then(res => {
          this.$message({
            message: '撤回成功',
            type: 'success'
          });
          this.dialogForwardVisible = false;
          this.getList();
        }).catch((_) => {
          this.dialogForwardVisible = false;
        });
      } else {
        this.$message({
          message: '请选择状态为询价中或待撤回的询价单!',
          type: 'error'
        });
        this.getList();
      }
    },
    Publish() {
      const conforms = this.multipleSelection.filter(u => u.state === '草稿' || u.state === '已撤回');
      const paramStr = JSON.stringify({
        // 先找到被选择的数据
        // 找到被选择数据的id,转成字符串格式
        keyValue: conforms.map(u => u.id).join(',')
      });
      this.listLoading = true;
      if (conforms && conforms.length > 0) {
        txQuots.Publish(paramStr).then(res => {
          this.$message({
            message: '发布成功',
            type: 'success'
          });
          this.dialogForwardVisible = false;
          this.getList();
        }).catch((_) => {
          this.dialogForwardVisible = false;
        });
      } else {
        this.$message({
          message: '请选择状态为草稿或已撤回的询价单！',
          type: 'error'
        });
        this.getList();
      }
    },
    handleUpdate(row) { // 弹出编辑框
      const paramStr = JSON.stringify({
        keyValue: row.id,
        fromPlan: 0
      });
      this.soltEditTime = false;
      this.crmTypenew = 'Tx_Quot';
      this.getApi().get(paramStr).then(response => {
        this.temp = response.result == null ? {} : response.result;
        this.accGuid = this.temp.orderDetail.map(u => u.accountId).join(',');
        this.checkFunction(this.beforUpdate);
        this.dialogStatus = 'update';
        this.dialogEditVisible = true;
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txQuots') {
        const paramStr = JSON.stringify({
          keyValue: row.id,
          fromPlan: 0
        });
        this.getApi().get(paramStr).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_quotsview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txQuots-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}

.txQuots .edit_dialog {
  height: calc(100vh - 106px) !important;
  box-sizing: border-box;
}

.txQuots .el-dialog {
  margin: 0 !important;
  box-sizing: border-box;
  width: 100% !important;

}
</style>
